import { render, staticRenderFns } from "./TechCanvas.vue?vue&type=template&id=1e82f501&scoped=true"
import script from "./TechCanvas.vue?vue&type=script&lang=js"
export * from "./TechCanvas.vue?vue&type=script&lang=js"
import style0 from "./TechCanvas.vue?vue&type=style&index=0&id=1e82f501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e82f501",
  null
  
)

export default component.exports